import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getAllDiscounts = async (filters, page, size) => {
  try {
    const response = await api.get(`/discount`, {
      headers: setAuthHeader(),
      params: {
        ...filters,
        page,
        size,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const createDiscount = async (discountsData) => {
  try {
    const response = await api.post('/discount', discountsData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao criar tabela de descontos.');
  }
};

export const getDiscountData = async (discountsId) => {
  try {
    const response = await api.get(`/discount/${discountsId}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar tabelas de descontos.');
  }
};

export const updateDiscount = async (discountsId, data) => {
  try {
    const response = await api.put(`/discount/${discountsId}`, data, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar a tabela de descontos.');
  }
};

export const deleteDiscount = async (discountsId, type) => {
  try {
    const response = await api.delete(`/discount/${discountsId}`, { 
      params: { type }, 
      headers: setAuthHeader() 
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao remover o desconto.');
  }
};